// React
import React, { Fragment, useState, useEffect } from 'react'

// Components
import FloatingCart from 'store/v2/react/scenes/cart/components/FloatingCart'
import { CartPicker } from 'store/modules/cart/FloatingCart/components/CartPicker'
import Launcher from 'store/modules/cart/FloatingCart/components/Launcher'

// Hooks
import { useSettings } from 'shared/utils/useSettings'

export const Cart = () => {
  const [showPicker, setShowPicker] = useState(true)

  const isShowCartBehavior = useSettings('store.behaviors.add_button') === 'show_cart'

  useEffect(() => {
    if (document.querySelector('bq-date-picker-modal')) {
      setShowPicker(false)
    }
  }, [])

  return (
    <div className="booqable-component">
      {isShowCartBehavior && (
        <Fragment>
          <div id="booqable-sidebar">
            <FloatingCart />
          </div>
          <Launcher />
        </Fragment>
      )}
      {showPicker && <CartPicker />}
    </div>
  )
}

export default Cart
